// src/i18n/es/operacion.ts
// «Operación» (w7.u2) — route /operacion, Dirección. Cinco cifras del
// director con delta y el marcador de tendencia, el sello de cobertura y
// frescura bajo cada número (02 S1.5), y los paneles de apoyo (embudo,
// tiempos, errores/abandono, pre-check-in, identificación). Los nombres de
// las métricas se traducen por su id en `insightV2.metrics`.
export const operacion = {
  name: 'Operación |||| Operación',
  subtitle: 'Las cifras del director, con qué falla debajo',

  noChanges: 'Ninguna cifra ha cambiado lo suficiente frente al periodo anterior.',

  // «Tres cosas que han cambiado»: one sentence per change the API states.
  changes: {
    periodDay: 'el %{day}',
    periodRange: 'del %{from} al %{to}',
    ops_arrivals: {
      up: 'Las llegadas subieron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'Las llegadas bajaron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
    ops_self_service_completed: {
      up: 'El autoservicio completado subió de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'El autoservicio completado bajó de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
    ops_containment: {
      up: 'Las llegadas resueltas sin recepción subieron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'Las llegadas resueltas sin recepción bajaron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
    ops_pre_checkin_share: {
      up: 'Las llegadas con pre-check-in subieron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'Las llegadas con pre-check-in bajaron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
    ops_time_to_key_median: {
      up: 'El tiempo de entrega de la llave subió de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'El tiempo de entrega de la llave bajó de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
    ops_incidents: {
      up: 'Las incidencias subieron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
      down: 'Las incidencias bajaron de %{previous} a %{current} (%{change}) frente al periodo anterior (%{period}).',
    },
  },

  sections: {
    stepFunnel: 'Recorridos en el kiosco',
    times: 'Tiempos',
    errorsAbandon: 'Errores y abandono',
    preCheckin: 'Pre-check-in',
    identification: 'Identificación',
    other: 'Otros indicadores',
  },

  export: {
    metric: 'Indicador',
    value: 'Valor',
  },

  help: {
    title: 'Operación',
    description:
      'La página semanal del director: seis cifras (llegadas, autoservicio completado, resueltas sin recepción, tiempo de entrega de la llave, llegadas con pre-check-in e incidencias) con su cambio frente al periodo anterior de la misma duración, las tres cifras que más han cambiado y, debajo, dónde falla — los recorridos en el kiosco, los tiempos, los errores y motivos de abandono, el pre-check-in y la identificación.',
    features: {
      cards: 'Cada cifra lleva su cambio frente al periodo anterior (en puntos para los porcentajes, en tiempo para la entrega de la llave), en verde si mejora y en rojo si empeora, y un sello gris con la frescura del dato o, si falta, el remedio exacto — nunca «estimado» ni «desconocido».',
      panels: 'Los paneles de apoyo agrupan el resto de indicadores de Operación por tema.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; el periodo por defecto son los últimos 30 días.',
    },
  },
};

export default operacion;
